import { Recordatorio } from '../../domain/entities/Recordatorio';
import { RecordatorioService } from '../services/RecordatorioService';

interface FindRecordatorioResult {
  success: boolean;
  recordatorio?: Recordatorio;
  message?: string;
}

export class FindRecordatorioUseCase {
  constructor(private recordatorioService: RecordatorioService) {}

  async execute(nroRecordatorio: number): Promise<FindRecordatorioResult> {
    if (!nroRecordatorio || nroRecordatorio <= 0) {
      return {
        success: false,
        message: 'El número de recordatorio debe ser un entero positivo'
      };
    }

    try {
      const recordatorio = await this.recordatorioService.findByNumero(nroRecordatorio);

      if (!recordatorio) {
        return {
          success: false,
          message: `No se encontró ningún recordatorio de pago con el número ${nroRecordatorio}`
        };
      }

      return { success: true, recordatorio };
    } catch (error) {
      return {
        success: false,
        message: 'Error al procesar la solicitud. Por favor, inténtelo de nuevo.'
      };
    }
  }
}
